export default __webpack_public_path__ + "static/media/Group 7.b98d2d62.png";